// Module
var code = `<div class="btn-group"
   ng-if="\$ctrl.task.approveUserIds.length > 1">
  <button
      ng-class="\$ctrl.buttonClass"
      class="btn dropdown-toggle action-button"
      data-toggle="dropdown">
    {{\$ctrl.buttonLabel}}<span class="caret"></span>
  </button>
  <ul class="dropdown-menu">
    <li ng-repeat="level in \$ctrl.levels">
      <a ng-click="\$ctrl.approvalAction(\$ctrl.task, \$event, level)">{{\$ctrl.levelLabel}} {{level + 1}}</a>
    </li>
  </ul>
</div>
<button
    ng-if="\$ctrl.task.taskGroup !== 'COMMAND_APPROVAL' || \$ctrl.task.approveUserIds.length === 1"
    class="btn action-button"
    ng-class="\$ctrl.buttonClass"
    ng-click="\$ctrl.approvalAction(\$ctrl.task, \$event)"
    type="button">
  {{\$ctrl.buttonLabel}}
</button>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/dashboard/actions/approval-action.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;